import { axiosConfig } from '../api/axios-config.js'

// Line 群組日誌
export const lineGroupLog = {
  // 取得日誌清單
  get: (params, token) => axiosConfig.get('/api/line-group-logs', { ...token, params }),

  // 取得單一日誌詳情
  getDetail: (id, token) => axiosConfig.get(`/api/line-group-logs/${id}`, token),

  // 更新狀態
  updateStatus: (id, data, token) => axiosConfig.patch(`/api/line-group-logs/${id}/status`, data, token),

  // 批量更新狀態
  batchUpdateStatus: (data, token) => axiosConfig.patch('/api/line-group-logs/batch-status', data, token),

  // 取得統計資訊
  getStats: (params, token) => axiosConfig.get('/api/line-group-logs/stats', { ...token, params }),
}
